import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'border-input border-bg-items-black relative flex h-13 w-13 items-center justify-center border-b-[2px] bg-white text-lg leading-[1.4] transition-all max-lg:h-9 max-lg:w-9 max-lg:text-sm',
    fakeCaretWrapper:
      'pointer-events-none absolute inset-0 flex items-center justify-center',
    fakeCaret: 'animate-caret-blink h-4 w-px bg-black duration-1000'
  },
  variants: {
    isActive: {
      true: {
        base: 'border-brand-400'
      }
    }
  },
  defaultVariants: {}
});
